import controller from './root.controller';
import template from './root.html';
import './root.scss';
/**
 * @ngdoc component
 * @name root
 * @description
 * The main wrapper component of the app. It's transcludes the router view.
 *
 * @memberof rootModule
 */
export default {
  /**
   * The controller class for the component.
   * @type {RootController}
   */
  controller,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
};



// WEBPACK FOOTER //
// ./src/frontend/modules/root/components/root/root.component.js